import { getBrand } from "@faire/help-center-utils/serialized-data/getBrand";
import { IBrand } from "@faire/web-api--source/indigofair/data/IBrand";

export const brandIsRejected = () => {
  const brand = getBrand();
  return (
    brand?.state === IBrand.State.REJECTED_FOR_FRAUD ||
    brand?.state === IBrand.State.REJECTED
  );
};
